import http from "./http";

export function get_classinfo_api(id) {
  return new Promise((resolve, reject) => {
    http.get("user/classinfo?school_id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function post_classinfo_api(id ,data) {
  return new Promise((resolve, reject) => {
    http.post("user/classinfo?school_id=" + id, data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function put_classinfo_api(id , data) {
  return new Promise((resolve, reject) => {
    http.put("user/classinfo?id=" + id , data).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

export function get_classinfoFilter_api(id) {
  return new Promise((resolve, reject) => {
    http.get("user/classinfo/filter?school_id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}

//删除
export function delete_classinfo_api(id) {
  return new Promise((resolve, reject) => {
    http.delete("user/classinfo?id=" + id).then(
      (response) => {
        resolve(response);
      },
      (err) => {
        reject(err);
      }
    );
  });
}
